import React from 'react';
import { useSearchPoint } from '@/hooks/apiHooks';
import { MyInfo } from '@/types/api';
import { DataListGrid, DataListGridItem } from '@/components/DataListGrid';
import Button from '@mui/material/Button';
import { PostMessageActionType, sendPostMessage } from '@/utils/postMessage';
import PlusIcon from '@/public/icons/plus.svg';
import { SubContentProps } from '@/components/MenuDrawer/MyMenuDrawer/SubMenu/LanguageSetting';
import ContentDescription from '@/components/MenuDrawer/MyMenuDrawer/@components/ContentDescription';
import { useMypageEventTracker } from '@/hooks/gtm/useGTMEventTracker';
import { MypageEventName } from '@/constant/gtm';
import { useTranslation } from 'react-i18next';
import { formatAsDate } from '@/utils/format';

const PersonalInfoLabels: { [key: string]: string } = {
  name: '이름',
  companyName: '법인',
  organizationFullName: '소속 (Full)',
  organizationShortName: '소속 (Short)',
  positionName: '직급',
  enterDate: '입사일',
  employmentTypeName: '현재 고용상태',
  employmentTypeDate: '고용발령일',
  employeeNumber: '사번',
  email: '이메일',
  phoneInside: '내선전화',
  phoneMobile: '휴대폰 번호',
  employeePoint: '직원 구매 포인트',
} as const;

export const PersonalInfoContent = (props: SubContentProps) => {
  const { myInfo } = props;
  console.log(myInfo);
  const { t } = useTranslation();
  const { data: pointData } = useSearchPoint(myInfo.employeeNumber);
  const mypageEventTracker = useMypageEventTracker();

  const requestAddEmployeePoint = () => {
    const url = `${process.env.NEXT_PUBLIC_IFRAME_URL}/intranet/approval/create?apv_type=54`;
    if (window?.isRNWebview) {
      sendPostMessage(PostMessageActionType.MOVE_TAB, {
        tabName: 'approval',
        url,
      });
    } else {
      window.open(url, '_blank', 'noreferrer');
    }
  };

  return (
    <>
      <ContentDescription hasVerticalMargin={true}>
        {t('MYPAGE.인사 정보는 HR팀을 통해서만 등록 및 수정이 가능합니다.')}
      </ContentDescription>
      <DataListGrid
        rowGap={'24px'}
        columnGap={'12px'}
        gridTemplateColumns={'112px 1fr'}
        sx={{
          marginTop: '16px',
          dt: { padding: '16px 0' },
          dd: {
            padding: '16px 12px',
            borderRadius: '8px',
            backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
            fontWeight: 500,
          },
        }}
      >
        {Object.keys(PersonalInfoLabels).map((key, index) => (
          <DataListGridItem
            key={`info-${index}`}
            label={t(PersonalInfoLabels[key])}
          >
            {key === 'employeePoint'
              ? `${(pointData?.employeePoint || 0).toLocaleString()}원`
              : key === 'enterDate'
              ? myInfo.enterDate
                ? formatAsDate(myInfo.enterDate)
                : '-'
              : key === 'employmentTypeDate'
              ? myInfo.employmentTypeDate
                ? formatAsDate(myInfo.employmentTypeDate)
                : '-'
              : Object.hasOwn(myInfo, key)
              ? `${myInfo[key as keyof MyInfo] || '-'}`
              : '-'}
          </DataListGridItem>
        ))}
      </DataListGrid>

      <Button
        sx={{ marginTop: '6px', marginLeft: 'auto', fontSize: '14px' }}
        onClick={() => {
          requestAddEmployeePoint();

          // GA Mypage - 24번
          mypageEventTracker(MypageEventName.clickEvent, {
            area_name: '인사정보 조회',
            contents: '추가요청',
            status: undefined,
            description: '직원 구매 포인트 추가요청',
          });
        }}
      >
        <PlusIcon width={'20px'} height={'20px'} stroke="#0066CC" />
        {t('MYPAGE.추가 요청')}
      </Button>
    </>
  );
};
